import { Component } from '@angular/core';
import { StatsService } from 'src/app/core/services/stats.service';

@Component({
  selector: 'app-docs-pending-by-user',
  templateUrl: './docs-pending-by-user.component.html',
  styleUrls: ['./docs-pending-by-user.component.scss']
})
export class DocsPendingByUserComponent {

  loading: boolean;
  mostrarError: boolean;
  mostrarListado: boolean;

  datosInforme = null; //Para el listado de documentos pendientes por usuario principal

  constructor( private statsService: StatsService ) {
    this.loading = false;
    this.mostrarError = false;
    this.mostrarListado = false;    
    
    this.datosInforme = [];
  }

  VisualizarDatos() {
    this.loading = true;

    this.mostrarError = false;
    this.mostrarListado = false;    
    this.datosInforme = [];

    this.statsService.obtenerListadoDocumentosPendientesPRIN().subscribe(datos => {

      this.datosInforme = datos;
      console.log(datos);

      this.loading = false;    
      this.mostrarListado = true;
    }, ( error ) => {
      this.loading = false;
      this.mostrarError = true;
    });
  }

  SumaParcial(indice: number, valor: number): number {

    let resultado: number = 0;

    this.datosInforme[indice].detalleUsuarios.forEach(element => {
      switch (valor) {
        case 0: resultado = resultado + element.pendientesEmitidas;
          break;
        case 1: resultado = resultado + element.pendientesRecibidas;
          break;
        case 2: resultado = resultado + element.pendientesTotal;
          break;
        case 3: resultado = resultado + element.pendientesRevisar;
          break;
      }
      
    });

    return resultado;
  }

  SumaTotal(valor: number): number {

    let resultado: number = 0;

    this.datosInforme.forEach(root => {
      root.detalleUsuarios.forEach(element => {
        switch (valor) {
          case 0: resultado = resultado + element.pendientesEmitidas;
            break;
          case 1: resultado = resultado + element.pendientesRecibidas;
            break;
          case 2: resultado = resultado + element.pendientesTotal;
            break;
          case 3: resultado = resultado + element.pendientesRevisar;
            break;
        }      
      });
    });

    return resultado;
  }  

}
